/**
* 功能: 新增、修改数据的弹框组件
*/

<template lang="pug">
  el-dialog(title="文章" width="80%" top="6vh" :visible.sync="dialogVisible")
    el-row(:gutter="10")
      el-form(:model="single" :rules="rules" label-width="70px" ref="form")
        el-col(:span="7")
          el-form-item(label="标题" prop="title")
            el-input(v-model="single.title")
          el-form-item(label="摘要" prop="abstract")
            el-input(type="textarea" v-model="single.abstract")
          el-form-item(label="精简显示" prop="compressed")
            el-checkbox(v-model="single.compressed" @click="forceUpdate")
          el-form-item(label="配图" prop="image")
            el-upload(:action='GLOBAL.uploadHost+"article/header_upload"'
              :headers='header' name="image" :auto-upload="true"
              accept="image/jpeg,image/png" :show-file-list="false"
              :on-success="handleUploaded" :before-upload="beforeAvatarUpload")
              img(v-if="single.image" :src='single.image' class="avatar" style="max-height:100px;max-width: 100%;")
              i.el-icon-plus.avatar-uploader-icon(v-else)
            el-button(v-if="single.img" icon="el-icon-delete" circle @click="handelRemoveImg")
          el-form-item(label="作者" prop="author")
            el-input(v-model="single.author")
          el-form-item(label="来源" prop="source")
            //- el-input(v-model="single.source")
            el-select(placeholder="请选择" v-model="single.source" clearable allow-create :filterable="true")
              el-option(v-for="item in source" :key="item.value" :label="item.label" :value="item.label")
          el-form-item(label="类型" prop="type")
            el-select(v-model="single.type"  placeholder="请选择" clearable :size="GLOBAL.SIZE_OF_INPUTBOX")
              el-option(v-for="item in type" :label="item.label" :value="item.value" :key="item.value" :disabled="item.disabled")
          el-form-item(label="发布日期" prop="pubDate")
            el-date-picker(v-model="single.pubDate"
                    type="datetime"
                    placeholder="选择发布日期和时间"
                    align="right")
          el-form-item(label="标签" prop="labels")
            InputTag(@getData="getLabels" :tagData="single.labels")
          el-form-item(label="报告" prop="report")
            el-autocomplete(style="width:100%;" v-model="single.reportName" :fetch-suggestions="searchBrief" clearable @clear="handelRemoveReport" @select="handelSelectReport")
          el-form-item(label="阅读量" prop="readingCount")
            el-input-number(v-model="single.readingCount" :step="1")
          //- el-form-item(label="属性" prop="properties")
          //-   el-select(v-model="single.properties"  multiple placeholder="选择属性类型" style="width:100%;")
          //-     el-option(v-for="item in properties" :key="item" :label="item" :value="item")
          //- el-form-item(label="行业" prop="industryId")
          //-   FrostIndustry(v-model="single.industryId" v-bind:name="single.industry" v-on:change="single.industry = $event")
          //- el-form-item(label="上架" prop="available")
          //-   el-checkbox(v-model="single.available" @click="forceUpdate")
        el-col(:span="17")
          el-form-item(label="内容" prop="paragraphs" )
            quill-editor(v-model="single.paragraphs" style="height:700px" :options="editorOption")
    .dialog-footer(slot="footer")
      el-button(@click="closeDialog") 关 闭
      el-button(@click="submit" type="primary") 确 定

</template>

<script>
import InputTag from '@/components/InputTag'
import api from '@/apis/brief'
import Enum from '@/apis/enum'
import passport from '@/javascripts/passport'
import FrostIndustry from '@/components/industry'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor, Quill } from 'vue-quill-editor'
import { ImageExtend, QuillWatch } from 'quill-image-extend-module'
Quill.register('modules/ImageExtend', ImageExtend)
export default {
  components: {
    quillEditor, FrostIndustry, InputTag
  },
  name: 'articleForm',
  computed: {
    header () {
      return {
        Authorization: 'Bearer ' + passport.getInfo()
      }
    }
  },
  data () {
    return {
      editorOption: {
        modules: {
          toolbar: {
            container: [
              [{ size: ['small', 'normal', 'large', 'huge'] }],
              ['bold', 'italic', 'underline', 'strike'],
              [{ color: [] }, { background: [] }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ align: [] }],
              ['link', 'image']],
            handlers: {
              image: function () {
                QuillWatch.emit(this.quill.id)
              }
            }
          },
          ImageExtend: {
            loading: true,
            name: 'image',
            action: this.GLOBAL.uploadHost + 'article/content_upload',
            headers: (xhr) => {
              xhr.setRequestHeader('Authorization', 'Bearer ' + passport.getInfo())
            },
            response: res => {
              return res.data
            }
          },
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          }
        }
      },
      dialogVisible: false,
      // properties: ['置顶', '滚动', '焦点', '重要'],
      inputVisible: false,
      inputValue: '',
      source: Enum.SOURCE,
      type: Enum.ARTICLE_TYPE,
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ]
      },
      single: { type: 0, industryId: [], industry: [], available: false, labels: [], status: 0 },
      searchTimeout: null
    }
  },
  methods: {
    // 前端移除头图显示
    handelRemoveImg () {
      this.single.image = ''
      this.$forceUpdate()
    },
    // vue 更新视图
    forceUpdate () {
      this.$forceUpdate()
    },
    // 根据关键词搜索报告
    searchBrief (queryString, cb) {
      clearTimeout(this.searchTimeout)
      if (!queryString || queryString.length < 2) return null
      this.searchTimeout = setTimeout(() => {
        api.searchBriefTitle({ text: queryString }).then(r => {
          const result = r.data.map(i => {
            return { value: i.title, id: i._id, industry: i.industry, industryId: i.industryId }
          })
          cb(result)
        }).catch(err => {
          this.$message({ message: err, type: 'error' })
        })
      }, 500)
    },
    // 获取文章标签
    getLabels (data) {
      this.single.labels = data
    },
    // 选择下拉的报告
    handelSelectReport (e) {
      this.single.report = e.id
      this.single.industryId = e.industryId
      this.single.industry = e.industry
    },
    // 移除关联报告
    handelRemoveReport () {
      this.single.report = ''
    },
    // 关闭弹框
    closeDialog () {
      this.dialogVisible = false
    },
    // 上传头像
    handleUploaded (val) {
      if (val.errCode === 0) {
        this.single.image = val.data.url
        this.$forceUpdate()
      }
    },
    // 初始化弹框数据
    show (val) {
      this.single = val || {}
      if (!val._id) {
        this.single.industryId = []
        this.single.industry = []
      }
      this.dialogVisible = true
    },
    // 提交数据到后台 -> 父子通信
    submit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.single, () => {
            this.closeDialog()
          })
        } else {
          return false
        }
      })
    },
    // 上传头像图片验证
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      this.loading = true
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
        this.loading = false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 1MB!')
        this.loading = false
      }
      return isJPG && isLt2M
    }
  }
}
</script>

<style>
.ql-toolbar {
  line-height: 22px !important;
}
</style>
<style scoped>
.quill-editor:not(.bubble) .ql-container,
.quill-editor:not(.bubble) .ql-container .ql-editor {
  height: 30rem;
  padding-bottom: 1rem;
}

.quill-editor {
  width: 100%;
  float: left;
}

.el-tag+.el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>